/** @param {unknown} value */
export function isProfileHashId(value) {
  if (value == null || value === "") {
    return false;
  }
  if (typeof value === "number") {
    return false;
  }
  if (typeof value !== "string") {
    return false;
  }
  return !/^\d+$/.test(value);
}

/**
 * Profile hashid from form-data / me (never numeric plainId).
 *
 * @param {object|null|undefined} storeProfile - Vuex getProfile
 * @param {object|null|undefined} me - Vuex getMe
 * @returns {string|null}
 */
export function resolveProfileHashId(storeProfile, me) {
  const candidates = [me?.profile?.id, storeProfile?.id];
  for (const candidate of candidates) {
    if (isProfileHashId(candidate)) {
      return candidate;
    }
  }
  return null;
}

/**
 * @param {import('vuex').Store} store
 * @returns {string|null}
 */
export function resolveProfileHashIdFromStore(store) {
  return resolveProfileHashId(store.getters.getProfile, store.getters.getMe);
}
